/**
 * How long until the call, in the largest unit that still says something useful.
 *
 * Only ever asked between a day out and ten minutes out. Further out the card
 * shows the timezone instead, because a client checking a week ahead wants to
 * know what the printed hour means rather than how many hours are left; closer
 * in the call is live and says so. Neither a day-counting branch nor a zero one
 * is here, for the same reason: they would be shapes nothing renders.
 */
export function countdown(ms: number): string {
  const minutes = Math.round(ms / 60000);
  if (minutes < 60) return `in ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `in ${hours}h ${rest}m` : `in ${hours}h`;
}
